import { get } from 'svelte/store'

import { configStore } from '@src/stores/config'
import { PassportEvents } from '@packages/utils/lib/events/events.enums'
import { dispatch } from '@packages/utils/lib/events/events'
import { analytics } from '@packages/utils/lib/mixpanel/mixpanel'
import { type TSuiAirDropAsset, type TSuiAirDropCoin } from '@src/utils/types'
import { SUI_CRED_DECIMALS } from '@src/constants/blockchain'
import { getSuiCredCoinType } from '@src/utils/blockchain'
import { suiAirdropPackages } from '@src/utils/config'
import { getAddress } from './blockchain'
import { initSuiClient } from '@src/libs/sui'

export async function requestAirDropCoin({
  amount,
  coinType = getSuiCredCoinType(),
  suiNetwork: airdropSuiNetwork,
}: TSuiAirDropCoin) {
  try {
    const { clientId, suiNetwork } = get(configStore)

    if (airdropSuiNetwork !== suiNetwork) {
      dispatch(PassportEvents.ERROR, {
        error: {
          message: 'Sui network of airdrop does not match current network',
          title: 'Air drop failed',
        },
      })
      throw new Error('Sui network of airdrop does not match current network')
    }

    const PACKAGE = suiAirdropPackages[suiNetwork]
    const client = await initSuiClient(PACKAGE, suiNetwork)

    const [conf] = await client.CredenzaAirdrop.getCreatedConfigs()
    const res = await client.CredenzaAirdrop.requestCoin(conf, amount * SUI_CRED_DECIMALS)

    dispatch(PassportEvents.REQUEST_AIRDROP, res)

    dispatch(PassportEvents.RECHECK_BALANCE)
    analytics.track('cp_airdrop_coin', {
      suiNetwork,
      clientId,
      coinType,
      to: await getAddress(),
      amount,
    })
  } catch (err) {
    dispatch(PassportEvents.ERROR, { error: { message: err.statusText, title: 'Air drop failed', code: err.status } })
    throw err
  }
}

export async function requestAirDropAsset({
  amount,
  packageId,
  configId,
  assetId,
  suiNetwork: airdropSuiNetwork,
}: TSuiAirDropAsset) {
  try {
    const { clientId, suiNetwork } = get(configStore)

    if (airdropSuiNetwork !== suiNetwork) {
      dispatch(PassportEvents.ERROR, {
        error: {
          message: 'Sui network of airdrop does not match current network',
          title: 'Air drop failed',
        },
      })
      throw new Error('Sui network of airdrop does not match current network')
    }

    const client = await initSuiClient(packageId, suiNetwork)

    const res = await client.CredenzaAirdrop.requestAsset(configId, +assetId, amount)

    dispatch(PassportEvents.REQUEST_AIRDROP, res)

    dispatch(PassportEvents.RECHECK_BALANCE)
    analytics.track('cp_airdrop_asset', {
      suiNetwork,
      clientId,
      packageId,
      assetId,
      configId,
      to: await getAddress(),
      amount,
    })
  } catch (err) {
    dispatch(PassportEvents.ERROR, { error: { message: err.statusText, title: 'Air drop failed', code: err.status } })
    throw err
  }
}
